import { PATHS } from '../../../routing-system/appPaths';
import { UserReportOption } from '../profile-sections/feedback/feedbackEnums';
import { ProfileMenuObject } from './profileMenuInterfaces';

export const profileMenuTypes = {
  DEFAULT_MENU: 'default',
  WALLET_MENU: 'wallet',
  PREFERENCES_MENU: 'preferences',
  SECURITY_MENU: 'security',
  ACCOUNT_MENU: 'account',
  REFER_A_FRIEND_MENU: 'refer a friend',
};

export const profileMenu: ProfileMenuObject[] = [
  {
    id: 'account',
    dataTestId: 'profile-menu-my-account',
    titleKey: 'profile_menu.my_account',
    collapse: true,
    subMenu: [
      {
        id: PATHS.APP.PROFILE.DETAILS,
        dataTestId: 'profile-menu-my-account-account-details',
        titleKey: 'common.account_details',
        collapse: false,
      },
      {
        id: PATHS.APP.PROFILE.CONTROL,
        dataTestId: 'profile-menu-my-account-staying-in-control',
        titleKey: 'common.staying_in_control',
        collapse: false,
      },
      {
        id: PATHS.APP.PROFILE.PREFERENCES,
        dataTestId: 'profile-menu-my-account-preferences',
        titleKey: 'common.preferences',
        collapse: false,
      },
      {
        id: PATHS.APP.PROFILE.CLOSE,
        dataTestId: 'profile-menu-my-account-close-account',
        titleKey: 'common.close_account',
        collapse: false,
      },
    ],
  },
  {
    id: 'wallet',
    dataTestId: 'profile-menu-my-wallet',
    titleKey: 'profile_menu.my_wallet',
    collapse: true,
    subMenu: [
      {
        id: PATHS.APP.PROFILE.DEPOSIT,
        dataTestId: 'profile-menu-my-wallet-deposit',
        titleKey: 'common.deposit',
        collapse: false,
      },
      {
        id: PATHS.APP.PROFILE.WITHDRAWAL,
        dataTestId: 'profile-menu-my-wallet-withdrawal',
        titleKey: 'common.withdrawal',
        collapse: false,
      },
      {
        id: PATHS.APP.PROFILE.HISTORY,
        dataTestId: 'profile-menu-my-wallet-transaction-history',
        titleKey: 'common.transaction_history',
        collapse: false,
      },
      {
        id: PATHS.APP.PROFILE.PROFIT_AND_LOSS_HISTORY,
        dataTestId: 'profile-menu-my-wallet-profit-and-loss',
        titleKey: 'common.profit_and_loss_history',
        collapse: false,
      },
      {
        id: PATHS.APP.PROFILE.NET,
        dataTestId: 'profile-menu-my-wallet-net-deposit',
        titleKey: 'common.net_deposit',
        collapse: false,
      },
    ],
  },
  {
    id: 'security',
    dataTestId: 'profile-menu-my-wallet-security',
    titleKey: 'profile_menu.security',
    collapse: true,
    subMenu: [
      {
        id: PATHS.APP.PROFILE.PASSWORD,
        dataTestId: 'profile-menu-my-wallet-change-password',
        titleKey: 'common.change_password',
        collapse: false,
      },
    ],
  },
];

export const PROMOTIONS_TAB_ID = 'promotions';
export const PROMOTIONS_INBOX = 'inbox';
export const MY_ACHIEVEMENTS_TAB_ID = 'my-achievements-tab';

export const profilePromoMenu: ProfileMenuObject[] = [
  {
    id: PROMOTIONS_TAB_ID,
    dataTestId: 'profile-menu-my-promotions',
    titleKey: 'profile_menu.my_promotions',
    collapse: false,
  },
  {
    id: PROMOTIONS_INBOX,
    dataTestId: 'profile-menu-my-inbox',
    titleKey: 'profile_menu.my_inbox',
    collapse: false,
    canHaveNotificationBadge: true,
  },
  {
    id: PATHS.APP.PROFILE.REFER_A_FRIEND,
    dataTestId: 'profile-menu-refer-a-friend',
    titleKey: 'common.refer_a_friend',
    collapse: false,
    isDisplayed: user =>
      !!user &&
      !!user.referralEnabled &&
      !user.hasBlockedSportsBook &&
      [PATHS.APP.PROFILE.PROMO_REFER_A_FRIEND, PATHS.APP.PROFILE.PROMO_REFER_A_FRIEND_HOW_IT_WORKS].indexOf(window.location.pathname) < 0,
  },
];

export const profileFeedbackMenu: ProfileMenuObject[] = [
  {
    id: UserReportOption.FEEDBACK,
    dataTestId: 'profile-menu-feedback',
    titleKey: 'profile.feedback',
    collapse: true,
    subMenu: [
      {
        id: UserReportOption.REPORT_BUG,
        dataTestId: 'profile-menu-feedback-report-a-bug',
        titleKey: 'profile.user_feedback.report_bug',
        collapse: false,
        displayIframe: true,
      },
      {
        id: UserReportOption.LEAVE_FEEDBACK,
        dataTestId: 'profile-menu-feedback-leave-feedback',
        titleKey: 'common.leave_feedback',
        collapse: false,
        displayIframe: true,
      },
      {
        id: UserReportOption.FEEDBACK_FORUM,
        dataTestId: 'profile-menu-feedback-feedback-forum',
        titleKey: 'profile.feedback_forum',
        collapse: false,
        displayIframe: true,
      },
    ],
  },
];

export const profileVerificationMenu: ProfileMenuObject[] = [
  {
    id: PATHS.APP.PROFILE.VERIFICATION.ROOT,
    dataTestId: 'profile-menu-verification',
    titleKey: 'profile.verification',
    collapse: true,
    canHaveNotificationWarning: true,
    subMenu: [
      {
        id: PATHS.APP.PROFILE.VERIFICATION.DOCUMENTS,
        dataTestId: 'profile-menu-verification-documents',
        titleKey: 'profile.verification.documents',
        collapse: false,
        canHaveNotificationBadge: true,
      },
      {
        id: PATHS.APP.PROFILE.VERIFICATION.EMPLOYMENT_DETAILS.ROOT,
        dataTestId: 'profile-menu-verification-employment-details',
        titleKey: 'profile.verification.employment_details',
        collapse: false,
        canHaveNotificationBadge: true,
      },
      {
        id: PATHS.APP.PROFILE.VERIFICATION.SAFER_GAMBLING.ROOT,
        dataTestId: 'profile-menu-verification-safer-gambling',
        titleKey: 'profile.verification.safer_gambling',
        collapse: false,
        canHaveNotificationBadge: true,
      },
    ],
  },
];
